import React from 'react';

const Laptop = () => {

    return (
        <div>
            <h1 className="text-center">Laptop</h1>
        </div>
    )
}


export default Laptop;